import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { ui } from '@/constants';
import { CustomerProfile, DietaryTag, DietaryTagGroup } from '@/models';
import { InteractionTrackingType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AccountManagementEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgDietaryFiltersModal',
})
export default class CmgDietaryFiltersModal extends Vue {
  tagList: string[] = [];

  get dietaryTagGroups(): DietaryTagGroup[] | undefined {
    return this.$appStore.state.menu.metadata?.dietaryTagGroups;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.dietaryFiltersModal.visible;
  }

  get args() {
    return this.$appStore.state.ui.modals.dietaryFiltersModal.args;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get headerText(): string {
    return this.$route.path === '/order/edit-account'
      ? 'Menu items will be tagged with these preferences.'
      : this.customer?.isGuest === false
      ? 'We’ll keep these tags saved in Personal & Preferences in your account.'
      : 'Set these tags for now or Sign In to keep them saved for later.';
  }

  @Watch('visible')
  async onVisibleUpdated(visible: boolean) {
    if (visible) {
      this.tagList = this.$appStore.state.customer.profile?.dietaryTags || [];
    }
  }

  onClose() {
    this.$services.ui.setModalVisibility('dietaryFiltersModal', false);
  }

  async onApply() {
    this.$services.ui.setModalVisibility('dietaryFiltersModal', false);
    if (!this.$appStore.state.customer.jwt) {
      await this.$services.customer.createAutogeneratedUser();
      await this.$services.customer.refreshCustomerProfileInfo();
    }

    const profile = this.$appStore.state.customer.profile;

    if (profile) {
      this.$services.customer.setProfile({ ...profile, dietaryTags: this.tagList });
    }
    if (profile && !profile.isGuest) {
      this.$services.customer.updateCustomer({ dietaryTags: this.tagList });
    }

    this.$services.analytics.send(new AccountManagementEvent(InteractionTrackingType.SelectNutritionPreferences));

    this.$services.ui.setModalVisibility('dietaryFiltersModal', false);
  }

  variableStyle(dietaryTagGroup: DietaryTagGroup): object {
    return { '--primary': `${dietaryTagGroup.badgeColor}`, '--secondary': `${dietaryTagGroup.secondaryBadgeColor}`}
  }

  toggleTag(tag: DietaryTag) {
    if (this.tagList.includes(tag.tagCode)) {
      this.tagList = this.tagList.filter(x => x != tag.tagCode);
    } else {
      // if group select type is single, deselect the other items in the group
      const tagGroup = this.$appStore.state.menu.metadata?.dietaryTagGroups.find(
        dtg => dtg.id === this.$appStore.state.menu.metadata?.dietaryTagsLookup[tag.tagCode]?.tagGroupId,
      );
      if (tagGroup?.selectType === 'single') {
        this.tagList = this.tagList.filter(t => this.$appStore.state.menu.metadata?.dietaryTagsLookup[t]?.tagGroupId !== tagGroup.id);
      }

      this.tagList.push(tag.tagCode);
    }
  }

  isTagSelected(tag: DietaryTag): boolean {
    return this.tagList.includes(tag.tagCode);
  }
}
